import React, { useState } from "react";
import FluxxConfig from "./FluxxConfig";

const UserEligibility: React.FC = ({members }) => {
  const [search, setSearch] = useState("");
  const [expanded, setExpanded] = useState<string | null>(null);

  const items = [
    { key: "Fluxx", label: "Fluxx User Eligibility" }
  ];

  const filtered = items.filter((i) =>
    i.label.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="bg-[#f6f4ef] min-h-screen font-sans">
      <div className="p-5">

        <div className="bg-white border border-gray-200 rounded-md">

          <div className="px-5 py-4 border-b border-gray-200 flex items-center">
            <div className="flex-1">
              <h2 className="text-md font-semibold text-gray-800">
                User Eligibility
              </h2>
            </div>
          </div>

          <div className="p-5">

            <input
              type="text"
              placeholder="Search..."
              className="w-full border border-gray-200 p-2 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-orange-400"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <div className="space-y-3">

              {filtered.map((item) => {
                const isExpanded = expanded === item.key;

                return (
                  <div
                    key={item.key}
                    className="border border-gray-200 rounded-md bg-white"
                  >

                    <div className="p-4 flex justify-between items-center">
                      <div className="text-sm font-medium text-gray-800">
                        {item.label}
                      </div>

                      <button
                        className="bg-orange-500 text-white px-3 py-1.5 rounded-md text-sm"
                        onClick={() =>
                          setExpanded(isExpanded ? null : item.key)
                        }
                      >
                        {isExpanded ? "Close" : "Check"}
                      </button>
                    </div>

                    {isExpanded && item.key === "Fluxx" && (
                      <div className="border-t border-gray-200 p-4 bg-[#fbfaf7]">
                        <FluxxConfig  members={members}/>
                      </div>
                    )}


                  </div>
                );
              })}

              {filtered.length === 0 && (
                <div className="text-sm text-gray-500 text-center py-6">
                  No items found
                </div>
              )}

            </div>

          </div>
        </div>

      </div>
    </div>
  );
};

export default UserEligibility;